import {useIsAdmin} from './useIsAdmin';
import {useIsManager} from './useIsManager';

/**
 * Returns true when the current user is an Admin OR a Manager.
 * Use this to gate UI/data that both roles share (e.g. card owner column,
 * admin-style filters, approval tables), as opposed to admin-only access.
 * @returns {boolean} True if the user is an Admin or a Manager.
 */
export const useIsAdminOrManager = () => {
  const isAdmin = useIsAdmin();
  const isManager = useIsManager();
  return isAdmin || isManager;
}
